exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#systemDetailsRetirever-wrapper .padding {\r\n            margin-bottom: 5%;\r\n        }\r\n\r\n#systemDetailsRetirever-wrapper .color:hover {\r\n            background-color: #007eed;\r\n        }\r\n\r\n#systemDetailsRetirever-wrapper .color:active {\r\n            background-color: #0084b4;\r\n        }", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./app/main/systemDetailsRetriever/system-details-retriever.component.css
 ** module id = 945
 ** module chunks = 2
 **/